import { createAsyncThunk } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash-es';

import type { Scene } from '../../../types/scene';
import type { Nullable } from '../../../types/utility';
import type { RootState } from '../../types';
import { getScenes } from '../scene.selectors';
import { NAME } from './const';
import { fetchSceneThunk } from './fetch-scene';

type SelectScenePayload = {
  sceneId: string;
  isGraphProvided: boolean;
};

type SelectSceneResult = {
  selectedScene: Nullable<Partial<Scene>>;
  isTemporaryScene: boolean;
};

export const selectSceneThunk = createAsyncThunk<SelectSceneResult, SelectScenePayload, { state: RootState }>(
  `${NAME}/selectSceneThunk`,
  async ({ sceneId, isGraphProvided }, { dispatch, getState }) => {
    const state = getState();
    const scenes = getScenes(state);

    const scene = scenes?.find((s) => s.id === sceneId);

    if (isGraphProvided) {
      return {
        selectedScene: scene ?? null,
        isTemporaryScene: false,
      };
    }

    if (scene && Boolean(scene?.temporaryData)) {
      return {
        selectedScene: !isEmpty(scene?.temporaryData) ? scene.temporaryData : null,
        isTemporaryScene: true,
      };
    }

    if (!scene || scene.lastModified) {
      const loadedScene = await dispatch(fetchSceneThunk({ sceneId })).unwrap();
      return {
        selectedScene: loadedScene ?? null,
        isTemporaryScene: false,
      };
    }

    return {
      selectedScene: null,
      isTemporaryScene: false,
    };
  },
);
